document.addEventListener('DOMContentLoaded', function () {
	console.log('✅ search redirect loaded');

	// Ambil elemen input pencarian
const form = document.querySelector('[data-quick-search-form]');

if (!form) return;

const searchInput = form.querySelector('[data-input]');


	// 🔸 Daftar kata → koleksi
	const collectionRedirects = {
  '10 10 shopify deals': '/id/collections/10-10-shopify-deals',
  '23fw': '/id/collections/23fw',
  '24fw 2nd drop': '/id/collections/24fw-2nd-drop',
  '24fw 3rd drop': '/id/collections/24fw-3rd-drop',
  '24fw accessories': '/id/collections/24fw-accessories',
  '24fw outlet collections': '/id/collections/24fw-outlet-collections',
  '24fw overseas exclusive': '/id/collections/24fw-overseas-exclusive',
  '24ss best artwork': '/id/collections/24ss-best-artwork',
  '24ss collection': '/id/collections/24ss-collection',
  '25fw': '/id/collections/25fw',
  '25fw ball cap overseas': '/id/collections/25fw-ball-cap-overseas',
  '25ss': '/id/collections/25ss',
  '25ss drop 4': '/id/collections/25ss-drop-4',
  '25ss feb drop 1': '/id/collections/25ss-feb-drop-1',
  '25ss may': '/id/collections/25ss-may',
  '8 8 special discount': '/id/collections/8-8-special-discount',
  'ac bear collection': '/id/collections/ac-bear-collection',
  'ac bear collections': '/id/collections/ac-bear-collections',
  'accessories outlet collections': '/id/collections/accessories-outlet-collections',
  'acme de la vie sanrio hello kitty': '/id/collections/acme-de-la-vie-sanrio-hello-kitty',
  'adlv gundam': '/id/collections/adlv-gundam',
  'adlv opanchu': '/id/collections/adlv-opanchu',
  'adlv sale': '/id/collections/adlv-sale',
  'adlv x lalala fest': '/id/collections/adlv-x-lalala-fest',
  'aksesoris': '/id/collections/aksesoris-korea',
  'alegeors picks': '/id/collections/alegeors-picks',
  'all products': '/id/collections/all-products',
  'all products 2ndanniversary': '/id/collections/all-products-2ndanniversary',
  'all products payday sep': '/id/collections/all-products-payday-sep',
  'all products sale collections excluded': '/id/collections/all-products-sale-collections-excluded',
  'atasan': '/id/collections/atasan-korea',
  'b1g1 the gift of season 2025': '/id/collections/b1g1-the-gift-of-season-2025',
  'baby face': '/id/collections/baby-face',
  'baby face outlet collections': '/id/collections/baby-face-outlet-collections',
  'back in stock': '/id/collections/back-in-stock',
  'bag outlet collections': '/id/collections/bag-outlet-collections',
  'baju crop top wanita': '/id/collections/baju-crop-top-wanita-korea',
  'baju lengan panjang': '/id/collections/baju-lengan-panjang-korea',
  'baju rajut': '/id/collections/baju-rajut-korea',
  'baju rajut wanita': '/id/collections/baju-rajut-wanita-korea',
  'ball caps': '/id/collections/ball-caps',
  'bear mascot': '/id/collections/bear-mascot',
  'belly gom': '/id/collections/belly-gom',
  'best seller': '/id/collections/best-seller',
  'best selling items': '/id/collections/best-selling-items',
  'black friday 2025': '/id/collections/black-friday-2025',
  'bottom outlet collections': '/id/collections/bottom-outlet-collections',
  'buy 1 get 1 free 15 18 august 2025': '/id/collections/buy-1-get-1-free-15-18-august-2025',
  'cardigan': '/id/collections/cardigan-korea',
  'cardigan outlet collections': '/id/collections/cardigan-outlet-collections',
  'cardigan pria': '/id/collections/cardigan-pria-korea',
  'cardigan rajut': '/id/collections/cardigan-rajut-korea',
  'cardigan rajut wanita': '/id/collections/cardigan-rajut-wanita-korea',
  'cardigan wanita': '/id/collections/cardigan-wanita-korea',
  'celana abu abu': '/id/collections/celana-abu-abu-korea',
  'celana beige': '/id/collections/celana-beige-korea',
  'celana cargo': '/id/collections/celana-cargo-korea',
  'celana cargo panjang': '/id/collections/celana-cargo-panjang-korea',
  'celana cargo panjang pria': '/id/collections/celana-cargo-panjang-pria-korea',
  'celana cargo pendek': '/id/collections/celana-cargo-pendek-korea',
  'celana cargo pria': '/id/collections/celana-cargo-pria-korea',
  'celana cargo wanita': '/id/collections/celana-cargo-wanita-korea',
  'celana corduroy': '/id/collections/celana-corduroy-korea',
  'celana denim': '/id/collections/celana-denim-korea',
  'celana hitam': '/id/collections/celana-hitam-korea',
  'celana hitam wanita': '/id/collections/celana-hitam-wanita-korea',
  'celana hotpants': '/id/collections/celana-hotpants-korea',
  'celana jeans hitam': '/id/collections/celana-jeans-hitam-korea',
  'celana jeans': '/id/collections/celana-jeans-korea',
  'celana jeans pria': '/id/collections/celana-jeans-pria-korea',
  'celana jeans sobek': '/id/collections/celana-jeans-sobek-korea',
  'celana jeans sobek wanita': '/id/collections/celana-jeans-sobek-wanita-korea',
  'celana jeans wanita': '/id/collections/celana-jeans-wanita-korea',
  'celana joger': '/id/collections/celana-joger-korea',
  'celana jogger pria': '/id/collections/celana-jogger-pria-korea',
  'celana jogger wanita': '/id/collections/celana-jogger-wanita-korea',
  'celana': '/id/collections/celana-korea',
  'celana lari pria': '/id/collections/celana-lari-pria-korea',
  'celana oversize pria': '/id/collections/celana-oversize-pria-korea',
  'celana panjang': '/id/collections/celana-panjang-korea',
  'celana panjang pria': '/id/collections/celana-panjang-pria-korea',
  'celana panjang wanita': '/id/collections/celana-panjang-wanita-korea',
  'celana pendek': '/id/collections/celana-pendek-korea',
  'celana pendek wanita': '/id/collections/celana-pendek-wanita-korea',
  'celana pria': '/id/collections/celana-pria-korea',
  'celana putih': '/id/collections/celana-putih-korea',
  'celana training jogger': '/id/collections/celana-training-jogger-korea',
  'celana training': '/id/collections/celana-training-korea',
  'celana training wanita': '/id/collections/celana-training-wanita-korea',
  'celana wanita': '/id/collections/celana-wanita-korea',
  'christmas special edition': '/id/collections/christmas-special-edition',
  'cny': '/id/collections/cny',
  'collection artwork': '/id/collections/collection-artwork',
  'collection baby face hoodie': '/id/collections/collection-baby-face_hoodie',
  'collection baby face t shirt': '/id/collections/collection-baby-face-t-shirt',
  'collection logo play': '/id/collections/collection-logo-play',
  'collection logo play artwork': '/id/collections/collection-logo-play-artwork',
  'crews picks': '/id/collections/crews-picks',
  'employee sale': '/id/collections/employee-sale',
  'end of season archive': '/id/collections/end-of-season-archive',
  'etc': '/id/collections/etc',
  'except markdown deals': '/id/collections/except-markdown-deals',
  'halloween 25fw': '/id/collections/halloween-25fw',
  'hat outlet collections': '/id/collections/hat-outlet-collections',
  'holiday collection': '/id/collections/holiday-collection',
  'hoodie anak': '/id/collections/hoodie-anak-korea',
  'hoodie hitam wanita': '/id/collections/hoodie-hitam-wanita-korea',
  'hoodie': '/id/collections/hoodie-korea',
  'hoodie outlet collections': '/id/collections/hoodie-outlet-collections',
  'hoodie wanita': '/id/collections/hoodie-wanita-korea',
  'hoshi collection': '/id/collections/hoshi-collection',
  'hoshi x adlv 24 fall winter collaboration': '/id/collections/hoshi-x-adlv-24-fall-winter-collaboration',
  'indonesia special collection': '/id/collections/indonesia-special-collection',
  'jacket outlet collections': '/id/collections/jacket-outlet-collections',
  'jaket baseball': '/id/collections/jaket-baseball-korea',
  'jaket bomber': '/id/collections/jaket-bomber-korea',
  'jaket casual': '/id/collections/jaket-casual-korea',
  'jaket casual pria': '/id/collections/jaket-casual-pria-korea',
  'jaket denim': '/id/collections/jaket-denim-korea',
  'jaket denim pria': '/id/collections/jaket-denim-pria-korea',
  'jaket denim wanita': '/id/collections/jaket-denim-wanita-korea',
  'jaket denim wanita oversize': '/id/collections/jaket-denim-wanita-oversize-korea',
  'jaket hitam': '/id/collections/jaket-hitam-korea',
  'jaket hitam wanita': '/id/collections/jaket-hitam-wanita-korea',
  'jaket hoodie': '/id/collections/jaket-hoodie-korea',
  'jaket hoodie pria': '/id/collections/jaket-hoodie-pria-korea',
  'jaket jeans': '/id/collections/jaket-jeans-korea',
  'jaket jeans wanita': '/id/collections/jaket-jeans-wanita-korea',
  'jaket': '/id/collections/jaket-korea',
  'jaket kulit': '/id/collections/jaket-kulit-korea',
  'jaket motor': '/id/collections/jaket-motor-korea',
  'jaket outdoor': '/id/collections/jaket-outdoor-korea',
  'jaket oversize': '/id/collections/jaket-oversize-korea',
  'jaket oversize pria': '/id/collections/jaket-oversize-pria-korea',
  'jaket panjang wanita': '/id/collections/jaket-panjang-wanita-korea',
  'jaket pria': '/id/collections/jaket-pria-korea',
  'jaket resleting wanita': '/id/collections/jaket-resleting-wanita-korea',
  'jaket varsity': '/id/collections/jaket-varsity-korea',
  'jaket wanita': '/id/collections/jaket-wanita-korea',
  'jaket zipper': '/id/collections/jaket-zipper-korea',
  'kaos abu abu': '/id/collections/kaos-abu-abu-korea',
  'kaos anak': '/id/collections/kaos-anak-korea',
  'kaos berkerah': '/id/collections/kaos-berkerah-korea',
  'kaos crop': '/id/collections/kaos-crop-korea',
  'kaos hitam': '/id/collections/kaos-hitam-korea',
  'kaos kerah lengan panjang': '/id/collections/kaos-kerah-lengan-panjang-korea',
  'kaos': '/id/collections/kaos-korea',
  'kaos lengan panjang': '/id/collections/kaos-lengan-panjang-korea',
  'kaos lengan panjang pria': '/id/collections/kaos-lengan-panjang-pria-korea',
  'kaos lengan panjang wanita': '/id/collections/kaos-lengan-panjang-wanita-korea',
  'kaos lengan pendek': '/id/collections/kaos-lengan-pendek-korea',
  'kaos lengan pendek pria': '/id/collections/kaos-lengan-pendek-pria-korea',
  'kaos lengan pendek wanita': '/id/collections/kaos-lengan-pendek-wanita-korea',
  'kaos merah': '/id/collections/kaos-merah-korea',
  'kaos oversize': '/id/collections/kaos-oversize-korea',
  'kaos oversize pria': '/id/collections/kaos-oversize-pria-korea',
  'kaos oversize wanita': '/id/collections/kaos-oversize-wanita-korea',
  'kaos panjang': '/id/collections/kaos-panjang-korea',
  'kaos polos': '/id/collections/kaos-polos-korea',
  'kaos pria': '/id/collections/kaos-pria-korea',
  'kaos putih': '/id/collections/kaos-putih-korea',
  'kaos wanita': '/id/collections/kaos-wanita-korea',
  'kaus kaki': '/id/collections/kaus-kaki-korea',
  'kemeja hitam': '/id/collections/kemeja-hitam-korea',
  'kemeja': '/id/collections/kemeja-korea',
  'kemeja lengan panjang pria': '/id/collections/kemeja-lengan-panjang-pria-korea',
  'kemeja panjang wanita': '/id/collections/kemeja-panjang-wanita-korea',
  'kemeja pria': '/id/collections/kemeja-pria-korea',
  'kemeja wanita': '/id/collections/kemeja-wanita-korea',
  'kids collection new arrivals': '/id/collections/kids-collection-new-arrivals',
  'kids hat outlet': '/id/collections/kids-hat-outlet',
  'kids hoodie outlet': '/id/collections/kids-hoodie-outlet',
  'kids outlet collections': '/id/collections/kids-outlet-collections',
  'kids socks outlet': '/id/collections/kids-socks-outlet',
  'kids sweatshirt outlet': '/id/collections/kids-sweatshirt-outlet',
  'knit': '/id/collections/knit-korea',
  'knit outlet collections': '/id/collections/knit-outlet-collections',
  'kupluk keren pria': '/id/collections/kupluk-keren-pria-korea',
  'long pants outlet collections': '/id/collections/long-pants-outlet-collections',
  'markdown aug': '/id/collections/markdown-aug',
  'new arrivals': '/id/collections/new-arrivals',
  'new drop bottom': '/id/collections/new-drop-bottom',
  'new drop gundam': '/id/collections/new-drop-gundam',
  'new drop kids': '/id/collections/new-drop-kids',
  'new drop outer': '/id/collections/new-drop-outer',
  'new drop top': '/id/collections/new-drop-top',
  'new drop woman collection': '/id/collections/new-drop-woman-collection',
  'outer': '/id/collections/outer-korea',
  'outer outlet collections': '/id/collections/outer-outlet-collections',
  'pakaian anak': '/id/collections/pakaian-anak-korea',
  'pants collection': '/id/collections/pants-collection',
  'permanent markdown check': '/id/collections/permanent-markdown-check',
  'ppg adlv': '/id/collections/ppg-adlv',
  'pre order 26ss': '/id/collections/pre-order-26ss',
  'restocked': '/id/collections/restocked',
  'shirt outlet collections': '/id/collections/shirt-outlet-collections',
  'shopify deals': '/id/collections/shopify-deals',
  'short pants outlet collections': '/id/collections/short-pants-outlet-collections',
  'socks outlet collections': '/id/collections/socks-outlet-collections',
  'special picks': '/id/collections/special-picks',
  'special picks for ramadhan': '/id/collections/special-picks-for-ramadhan',
  'ss25 3rd drop': '/id/collections/ss25-3rd-drop',
  'ss25 new drop': '/id/collections/ss25-new-drop',
  'sweater anak': '/id/collections/sweater-anak-korea',
  'sweater hitam wanita': '/id/collections/sweater-hitam-wanita-korea',
  'sweater': '/id/collections/sweater-korea',
  'sweater oversize wanita': '/id/collections/sweater-oversize-wanita-korea',
  'sweater pria': '/id/collections/sweater-pria-korea',
  'sweater rajut': '/id/collections/sweater-rajut-korea',
  'sweater rajut pria': '/id/collections/sweater-rajut-pria-korea',
  'sweater rajut wanita': '/id/collections/sweater-rajut-wanita-korea',
  'sweater wanita': '/id/collections/sweater-wanita-korea',
  'sweatshirt outlet collections': '/id/collections/sweatshirt-outlet-collections',
  't shirt outlet collections': '/id/collections/t-shirt-outlet-collections',
  'tas kecil': '/id/collections/tas-kecil-korea',
  'tas kecil pria': '/id/collections/tas-kecil-pria-korea',
  'tas kecil wanita': '/id/collections/tas-kecil-wanita-korea',
  'tas': '/id/collections/tas-korea',
  'tas pinggang': '/id/collections/tas-pinggang-korea',
  'tas pinggang pria': '/id/collections/tas-pinggang-pria-korea',
  'tas pria': '/id/collections/tas-pria-korea',
  'tas punggung wanita': '/id/collections/tas-punggung-wanita-korea',
  'tas ransel': '/id/collections/tas-ransel-korea',
  'tas ransel pria': '/id/collections/tas-ransel-pria-korea',
  'tas ransel wanita': '/id/collections/tas-ransel-wanita-korea',
  'tas selempang pria': '/id/collections/tas-selempang-pria-korea',
  'tas selempang wanita': '/id/collections/tas-selempang-wanita-korea',
  'tas wanita': '/id/collections/tas-wanita-korea',
  'top outlet collections': '/id/collections/top-outlet-collections',
  'topi baseball': '/id/collections/topi-baseball-korea',
  'topi bucket': '/id/collections/topi-bucket-korea',
  'topi hitam': '/id/collections/topi-hitam-korea',
  'topi keren': '/id/collections/topi-keren-korea',
  'topi': '/id/collections/topi-korea',
  'topi kupluk': '/id/collections/topi-kupluk-korea',
  'topi pria': '/id/collections/topi-pria-korea',
  'topi wanita': '/id/collections/topi-wanita-korea',
  'with jeonghan': '/id/collections/with-jeonghan',
  'woman outlet collections': '/id/collections/woman-outlet-collections',
  'womans collection': '/id/collections/womans-collection',
  'year end sale 2023': '/id/collections/year-end-sale-2023',
  'year end sale 2025': '/id/collections/year-end-sale-2025'
};


form.addEventListener('submit', function (e) {

        const val = searchInput.value.trim().toLowerCase();

        if (collectionRedirects[val]) {

            e.preventDefault();
            e.stopImmediatePropagation();

            window.location.href = collectionRedirects[val];

        }

    }, true);
});
